import { generateTypes } from 'reducers/utils/HttpReducerHelper';

const contactDetails = generateTypes('FUNDING_SEARCH', 'CONTACT_DETAILS');

export { contactDetails };
